import React, { memo } from 'react'
import {
    ColDef,
    ICellRendererParams,
    ValueFormatterParams,
} from 'ag-grid-community'
import { AgGridReact } from 'ag-grid-react'
import { Paper } from '@mui/material'
import { VerdictType } from 'components'
import { amountValueFormatter } from './ChargebacksGrid'
import { IssuerDocsCell } from '../../ChargebacksAGGrid/grids/Cells'

interface IRowDef {
    [key: string]: any
}

export const ChargebacksGridDetails = (props: ICellRendererParams) => {
    const { data: rowData } = props

    const columns: ColDef[] = [
        {
            headerName: 'Dispute Ref. #',
            field: 'dispute_reference_number',
            minWidth: 150,
        },
        { headerName: 'Case Number', field: 'case_no', minWidth: 150 },
        { headerName: 'Type', field: 'type', minWidth: 140 },
        { headerName: 'Case Status', field: 'case_status', minWidth: 150 },
        { headerName: 'Case Note', field: 'case_note', minWidth: 160 },
        {
            headerName: 'Creation Date',
            field: 'creation_date',
            minWidth: 150,
            cellClass: ['emp-agDataGrid-columnAlignCenter'],
        },
        {
            headerName: 'Verdict',
            field: 'verdict',
            minWidth: 105,
            cellRenderer: memo((params: ICellRendererParams) => (
                <VerdictType
                    verdict={params.data.verdict}
                    size="small"
                    className={'emp-verdictIcon'}
                />
            )),
        },
        {
            headerName: 'Dispute Amt.',
            field: 'dispute_amt',
            minWidth: 145,
            cellClass: ['emp-agDataGrid-columnAlignRight'],
            valueFormatter: (params: ValueFormatterParams) =>
                amountValueFormatter(params.value),
        },
        { headerName: 'Dispute CUR', field: 'dispute_currency', minWidth: 145 },
        // { headerName: 'Account', field: 'account', minWidth: 150, },
        {
            headerName: 'Account Number',
            field: 'account_number',
            minWidth: 170,
        },
        {
            headerName: 'Merchant Name',
            field: 'merchant_name',
            minWidth: 160,
        },
        { headerName: 'Transaction ID', field: 'arn', minWidth: 155 },
        {
            headerName: 'Trans Date',
            field: 'trans_date',
            minWidth: 135,
            cellClass: ['emp-agDataGrid-columnAlignCenter'],
        },
        {
            headerName: 'Trans. Amt.',
            field: 'trans_amt',
            minWidth: 135,
            cellClass: ['emp-agDataGrid-columnAlignRight'],
            valueFormatter: (params: ValueFormatterParams) =>
                amountValueFormatter(params.value),
        },
        { headerName: 'Trans. CUR', field: 'trans_currency', minWidth: 135 },
        { headerName: 'Auth ID', field: 'auth_no', minWidth: 110 },
        {
            headerName: 'Card BIN',
            field: 'cc_bin',
            minWidth: 115,
            cellClass: ['emp-agDataGrid-columnAlignRight'],
        },
        {
            headerName: 'Card Last Four',
            field: 'cc_last_four',
            minWidth: 155,
            cellClass: ['emp-agDataGrid-columnAlignRight'],
        },
        {
            headerName: 'View',
            field: 'document',
            menuTabs: [],
            type: 'icon',
            sortable: false,
            minWidth: 85,
            maxWidth: 85,
            pinned: 'right',
            headerClass: ['emp-agDataGrid-headerAlignCenter'],
            cellStyle: {
                textAlign: 'center',
            },
            lockPinned: true,
            cellRenderer: memo((params: ICellRendererParams) => (
                <IssuerDocsCell
                    issuerDocs={params.data.issuer_docs ?? []}
                    caseId={params.data.id}
                    rowIndex={params.rowIndex}
                    testId={'caseActivityInnerGrid'}
                    setAlertSnackbarMainProps={() => {}}
                    setAlertSnackbarMainOpen={() => {}}
                />
            )),
        },
    ]
    const rows: IRowDef[] = rowData.details_data

    return (
        <div id={'chargebacksGridDetailsAG'}>
            <Paper
                className="emp-gridContainer"
                style={{
                    height: `${35 * rows?.length + 80}px`,
                }}
            >
                {rows?.length ? (
                    <AgGridReact
                        rowData={rows}
                        columnDefs={columns}
                        overlayNoRowsTemplate={`<span class="ag-overlay-loading-center">No Records Found!</span>`}
                        defaultColDef={{
                            flex: 1,
                            minWidth: 80,
                            resizable: true,
                            menuTabs: [],
                            sortable: false,
                        }}
                        rowHeight={35}
                        headerHeight={30}
                        getContextMenuItems={() => []}
                    />
                ) : (
                    <div className="emp-noData">No Records Found</div>
                )}
            </Paper>
        </div>
    )
}
